import { render, staticRenderFns } from "./OrganizationMember.vue?vue&type=template&id=6982f294&scoped=true"
import script from "./OrganizationMember.vue?vue&type=script&lang=js"
export * from "./OrganizationMember.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMember.vue?vue&type=style&index=0&id=6982f294&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982f294",
  null
  
)

export default component.exports